export { renderSwitch_unstable as renderSwitch } from '@fluentui/react-switch';
